/**
 * Get the default review year.
 * Returns 2025 until December 2026, then uses the current year.
 */
export function getDefaultReviewYear(): number {
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()
  
  // Default to 2025 until December 2026 (i.e., before January 2027)
  if (currentYear < 2027) {
    return 2025
  }
  
  return currentYear
}

